import { ChevronDown } from 'lucide-react';
import { CSSProperties } from 'react';
import * as S from './TableHeader.styles';

export type TableHeaderFilters = {
  order?: string;
  orderBy?: 'asc' | 'desc';
};

export type TableHeaderProps = {
  titles: {
    title: string;
    key?: string;
  }[];
  wrapperStyles?: CSSProperties;
  filters?: TableHeaderFilters;
  onChange?: (data: TableHeaderFilters) => void;
};

const TableHeader = ({ titles, onChange, filters = {}, wrapperStyles }: TableHeaderProps) => {
  const handleSort = (title: string) => () => {
    onChange?.({
      order: title,
      orderBy: filters.order === title && filters.orderBy === 'asc' ? 'desc' : 'asc',
    });
  };

  return (
    <S.Wrapper>
      <S.Inner style={wrapperStyles}>
        {titles.map((item) => (
          <S.Title
            key={item.title}
            sx={{
              cursor: item.key ? 'pointer' : 'default',
            }}
            {...(item.key && { onClick: handleSort(item.key) })}
          >
            <span>{item.title}</span>
            {item.key && item.key === filters?.order && (
              <S.Icon
                sx={{
                  transform: filters.orderBy === 'asc' ? 'rotate(180deg)' : 'rotate(0deg)',
                }}
              >
                <ChevronDown />
              </S.Icon>
            )}
          </S.Title>
        ))}
      </S.Inner>
    </S.Wrapper>
  );
};

export default TableHeader;
